import { render, staticRenderFns } from "./PillThemes.vue?vue&type=template&id=4d0656de&"
import script from "./PillThemes.vue?vue&type=script&lang=js&"
export * from "./PillThemes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports